import { render } from "./Jogos.vue?vue&type=template&id=6144a2ae&scoped=true"
import script from "./Jogos.vue?vue&type=script&lang=js"
export * from "./Jogos.vue?vue&type=script&lang=js"

import "./Jogos.vue?vue&type=style&index=0&id=6144a2ae&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144a2ae"]])

export default __exports__